import { useTranslation } from 'react-i18next';
import {
  REDUCTION_STRATEGY_OPTIONS,
  type SupplyAgentReductionStrategy,
} from '@/modules/supply/components/supplyAgentRuleUtils';

interface SupplyAgentReductionStrategyPickerProps {
  value: SupplyAgentReductionStrategy;
  disabled?: boolean;
  compact?: boolean;
  onChange: (strategy: SupplyAgentReductionStrategy) => void;
}

export function SupplyAgentReductionStrategyPicker({
  value,
  disabled = false,
  compact = false,
  onChange,
}: SupplyAgentReductionStrategyPickerProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-1">
      {REDUCTION_STRATEGY_OPTIONS.map((option) => {
        const selected = value === option.id;
        return (
          <button
            key={option.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.id)}
            className={`${
              compact ? 'rounded px-1.5 py-0.5 text-[10px]' : 'rounded-md px-2 py-1 text-[11px]'
            } font-medium transition-colors disabled:opacity-60 ${
              selected
                ? 'bg-amber-700 text-white'
                : 'bg-white text-amber-900 border border-amber-200 hover:bg-amber-100'
            }`}
          >
            {t(option.labelKey)}
          </button>
        );
      })}
    </div>
  );
}
